import type { ISerialize } from '@/objects/ISerialize';

export class ChronoTrack implements ISerialize {
    public MacAddress: string;

    public Serial: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { MacAddress?: string | null; Serial?: string | null }) {
        this.MacAddress = values.MacAddress ?? '';

        this.Serial = values.Serial ?? '';
    }

    public serialize(): string {
        return '{' + `"MacAddress": ${JSON.stringify(this.MacAddress)}` + ',' + `"Serial": ${JSON.stringify(this.Serial)}` + '}';
    }

    /**
     * Creates an instance of ChronoTrack from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { MacAddress?: string | null; Serial?: string | null }): ChronoTrack {
        return new ChronoTrack(values);
    }

    public static _FromServerJson(json: any): ChronoTrack {
        return new ChronoTrack({ MacAddress: json.MacAddress ?? '', Serial: json.Serial ?? '' });
    }

    /**
     * Creates an instance of ChronoTrack from another instance of ChronoTrack.
     * @param other The ChronoTrack you want to clone
     * @returns A cloned ChronoTrack
     */
    public static FromOther(other: ChronoTrack): ChronoTrack {
        return ChronoTrack._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ChronoTrack.FromOther(this);
    }

    static NAME_OF_CLASS = 'ChronoTrack';
}
